export default __webpack_public_path__ + "static/media/Guesswho3.cabd6ccb.PNG";